"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Favorite = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _Lock = _interopRequireDefault(require("@material-ui/icons/Lock"));

var _solarReact = require("@solar/solar-react");

var _CertificateList = _interopRequireDefault(require("../Certificate/CertificateList"));

var _ACLRequestList = _interopRequireDefault(require("../Certificate/ACLRequestList"));

var _CustomerInfo = _interopRequireDefault(require("./CustomerInfo"));

var _excluded = ["customer", "history", "action", "handleDetailViewToggle", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CustomerSheet = function CustomerSheet(_ref) {
  var customer = _ref.customer,
      history = _ref.history,
      action = _ref.action,
      handleDetailViewToggle = _ref.handleDetailViewToggle,
      labels = _ref.labels,
      other = _objectWithoutProperties(_ref, _excluded);

  var person = customer.person,
      favouriteCertificates = customer.favouriteCertificates,
      accessRequests = customer.accessRequests;
  var fullName = person.fullName,
      avatar = person.avatar,
      _person$hasSharedProf = person.hasSharedProfile,
      hasSharedProfile = _person$hasSharedProf === void 0 ? true : _person$hasSharedProf; // if users profile was not shared, all info is missing

  if (!hasSharedProfile) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.CoverView, {
      title: fullName,
      cover: avatar && avatar.src
    }, /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
      label: labels.notShared,
      Icon: _Lock["default"]
    }), ";");
  }

  var tabs = {
    info: {
      label: labels.tabs.info,
      component: /*#__PURE__*/_react["default"].createElement(_CustomerInfo["default"], _extends({
        customer: customer,
        person: person
      }, other))
    },
    favorites: {
      label: labels.tabs.favorites,
      component: favouriteCertificates && favouriteCertificates.length > 0 ? /*#__PURE__*/_react["default"].createElement(_CertificateList["default"], {
        certificates: favouriteCertificates.slice().sort(function (a, b) {
          return a.key < b.key ? -1 : 1;
        }),
        openCertificate: function openCertificate(certificateId) {
          return history.push("/certificates/".concat(certificateId));
        },
        hideOwner: true,
        labels: labels
      }) : /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
        label: labels.empty.favorites,
        Icon: _Favorite["default"]
      })
    },
    Requests: {
      label: labels.tabs.requests,
      component: accessRequests && accessRequests.length > 0 ? /*#__PURE__*/_react["default"].createElement(_ACLRequestList["default"], {
        requests: accessRequests,
        openRequest: function openRequest(id) {
          return handleDetailViewToggle('aclrequest', id);
        }
      }) : /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
        label: labels.empty.requests,
        Icon: _Lock["default"]
      })
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_solarReact.CoverTabView, {
    title: fullName,
    cover: avatar && avatar.src,
    tabs: tabs,
    action: action
  });
};

var _default = CustomerSheet;
exports["default"] = _default;